export default __webpack_public_path__ + "img/1a4e2753648f3311073586938f6183ff.png";